import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../styles/Customers.scss';
import { faDeleteLeft, faDumpster, faEdit, faEllipsis, faIndustry, faRemove, faL, faRightFromBracket, faSearch, faTrash, faTrashAlt, faTruck, faUsers, faXmarkCircle } from '@fortawesome/free-solid-svg-icons';
import { Button, Dropdown, Form, Spinner } from 'react-bootstrap';
import UniInput, { FormControlElement } from '../components/UniInput/UniInput';
import UniPagination from '../components/UniPagination/UniPagination';
import { ChangeEvent, useEffect, useState } from 'react';
import { useUserStore } from '../store/user';
import Skeleton from 'react-loading-skeleton';
import { useNavigate } from 'react-router-dom';
import { getAccessAsToken } from '../services/userService';
import { UserStatus } from '../types/userStatus';
import { CustomerResponseDto, getCustomerDataByIssuer, getCustomerPaged, getUserByCustomerPaged, putEnabledAfterHour } from '../services/customerService';
import UniModal from '../components/UniModal/UniModal';
import { decryptByte, encryptByte } from '../helpers/encrypt';
import { useTranslation } from 'react-i18next';
import Switch from "react-switch";
import { boolean } from 'yargs';
import { isSuper } from '@babel/types';
import { Material, getMaterialsByIssuer } from '../services/materialService';
import { VeichleCustomer, getVeichlesByCustomer, postVeichlesByCustomer, putVeichlesByCustomer } from '../services/veichleService';
import { faCheckCircle } from '@fortawesome/free-regular-svg-icons';

type SearchForm = {
    search?: string,
    status?: string,
    materialCode?: string
};

type ModalQuantity = {
    show: boolean,
    addShow: boolean,
    isEdit?: boolean,
};

type SelectedConfigQuantity = {
    product?: string,
    vehicle?: string,
    incoterm?: string,
    min?: string,
    max?: string,
    active?: boolean
};

const Customers = () => {
    const [afterHours, setAfterHours] = useState<Map<string,boolean> | undefined>(new Map<string,boolean>());
    const [usersCustomers, setCustomer] = useState<CustomerResponseDto[] | undefined>();
    const [showModal, setShowModal] = useState(false);
    const [loadingAccessAs, setLoadingAccessAs] = useState(false);
    const [loadingProduct, setLoadingProduct] = useState(false);
    const [loadingVehicleConfig, setLoadingVehicleConfig] = useState(false);
    const [loadingEmails, setLoadingEmails] = useState(false);
    const [selectedIssuerName, setSelectedIssuerName] = useState('');
    const [errorAccessAs, setErrorAccessAs] = useState(``);
    const [successMessage, setSuccessMessage] = useState(``);
    const [search, setSearch] = useState<SearchForm>();
    const [error, setError] = useState<string>();
    const [usersEmail, setEmails] = useState<string[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [totalPages, setTotalPages] = useState<number>();
    const [totalItems, setTotalItems] = useState<number>();
    const [take, setTake] = useState<any>(10);
    const [page, setPage] = useState<number>(1);
    const [modalQuantity, setModalQuantity] = useState<ModalQuantity>();
    const [selectedCustomer, setSelectedCustomer] = useState<string>('');
    const [selectedCustomerContry, setSelectedCustomerCountry] = useState<string>('BR');
    const [customerProducts, setCustomerProducts] = useState<Material[] | null>(null);
    const [customerVehicles, setCustomerVehicles] = useState<any[] | null>(null);
    const [customerIncoterms, setCustomerIncoterms] = useState<any[] | null>(null);
    const [enableModalInputs, setEnableModalInputs] = useState(false);
    const [selectedConfig, setSelectedConfig] = useState<SelectedConfigQuantity>();
    const [vehiclesByCustomer, setVehiclesByCustomer] = useState<VeichleCustomer[]>();
    const [vehiclesByCustomerFiltered, setVehiclesByCustomerFiltered] = useState<VeichleCustomer[]>();
    const [selectedVehicleItem, setSeletecVehicleItem] = useState<VeichleCustomer>();
    const [validationError, setValidationError] = useState<string>();
    const [reload, setReload] = useState(false);
    const { loginData, darkMode } = useUserStore();
    const navigate = useNavigate();
    const { i18n, t } = useTranslation();
    const [toggled, setToggle] = useState<boolean>(false);

    useEffect(() => {
        if (localStorage.getItem('tkn')) {
            getUsers();
        }
    }, [loginData.id, take, page, reload]);

    const getAfterHour = (issuer: string) =>
    {
        setToggle(afterHours?.get(issuer) ?? false);
    }

    const setAfterHour = (issuer: string) =>
    {
        setToggle(!(afterHours?.get(issuer) ?? false));
        putEnabledAfterHour(issuer, !(afterHours?.get(issuer) ?? false));
        afterHours?.set(issuer, !(afterHours?.get(issuer) ?? false));
    }


    const hideModalQuantity = () => {
        setCustomerProducts(null);
        setCustomerIncoterms(null);
        setCustomerVehicles(null);
        setEnableModalInputs(false);
        setSelectedConfig({});
        setModalQuantity({show: false, addShow: false, isEdit: false})
    }

    const getUsers = () => {
        setLoading(true);
        setError('');
        getCustomerPaged(take, page, search?.search ?? '')
            .then(response => {
                if (!response.success) {
                    setError(response.error);
                }
                else {
                    setCustomer(response.data);
                    setTotalItems(response.totalItems);
                    setTotalPages(response.totalPages);

                    var customersHours = new Map<string, boolean>();

                    response.data.map(d => {
                        if(d.enabledOrderAfterHour == null || d.enabledOrderAfterHour === undefined)
                            d.enabledOrderAfterHour = false;

                        customersHours.set(d.issuer, d.enabledOrderAfterHour);
                    })

                    setAfterHours(customersHours);

                }
            })
            .catch(e => console.log(e))
            .finally(() => setLoading(false))
    }

    const openModalQuantity = (customerCode: string, country: string = `BR`) => {
        setSelectedCustomer(customerCode);
        setSelectedCustomerCountry(country);
        setModalQuantity({show: true, addShow: false});
        getVeichlesByCustomer(customerCode)
        .then(r => {
            if (r.success) {
                setVehiclesByCustomer(r.data);
                setVehiclesByCustomerFiltered(r.data);
            } else {
                setVehiclesByCustomer([]);
            }
        })
    }

    const getCustomerMaterials = () => {
        setModalQuantity({show: true, addShow: true, isEdit: false})
        setLoadingProduct(true);
        setValidationError('');
        getMaterialsByIssuer(selectedCustomer)
        .then(materialsResponse => {
            if (materialsResponse.success) {
                setCustomerProducts(materialsResponse.materials);
                setEnableModalInputs(true);
            }
        })
        .finally(() => setLoadingProduct(false))
    }

    const selectedProduct = (value: string) => {
        setSelectedConfig({...selectedConfig, product: value});
        setLoadingVehicleConfig(true);
        getCustomerDataByIssuer(selectedCustomer, value)
        .then(r => {
            if (r.success) {
                let incoterms = selectedCustomerContry === `BR` ? ['CEF', 'FOB'] : ['CPT', 'FCA']
                let vehicles: any[] = [];
                if (r?.data?.defaultDataResponseDto?.length > 0) {
                    vehicles = [];
                    incoterms = [];
                    r?.data?.defaultDataResponseDto?.forEach(d => {
                        if (!incoterms.some(i => i === d.Incoterm)) {
                            incoterms.push(d.Incoterm)
                        }
                    });
                    let tms = r?.data?.defaultDataResponseDto?.map(d => d.FreightMaterialAgent)

                    tms?.forEach(tm => {
                        if (r?.data?.veichleTypeResponseDto.some(d => d?.tms?.some(t => t.tm === tm) ?? false)) {
                            const firstVehicle = r?.data?.veichleTypeResponseDto.filter(d => d?.tms?.some(t => t.tm === tm) ?? false)?.[0];
                            vehicles.push({
                                id: firstVehicle.id,
                                tm: tm,
                                description: firstVehicle.veichleDescriptions?.[0].description ?? ''
                            });
                        }
                    });
                } else {
                    r?.data?.veichleTypeResponseDto.forEach(vehicle => {
                        if (!vehicles.some(v => v.id === vehicle.id)) {
                            vehicles.push({
                                id: vehicle.id,
                                tm: vehicle.tm,
                                description: vehicle.veichleDescriptions?.[0].description ?? ''
                            });
                        }
                    })
                }

                setCustomerIncoterms(incoterms);
                setCustomerVehicles(vehicles);
                setSelectedConfig({...selectedConfig, incoterm: incoterms?.[0], vehicle: vehicles?.[0]?.id, product: value});
            }
        })
        .finally(() => setLoadingVehicleConfig(false))
    }

    const addVehicleConfig = () => {
        if (Number(selectedConfig?.min ?? '0') > Number(selectedConfig?.max ?? '0')) {
            setValidationError(t('modalQuantity.validation'));
            return;
        }

        const data: VeichleCustomer = {
            active: true,
            incoterm: selectedConfig?.incoterm ?? '',
            issuer: selectedCustomer,
            materialCode: selectedConfig?.product ?? '',
            maxValue: Number(selectedConfig?.max ?? '0'),
            minValue: Number(selectedConfig?.min ?? '0'),
            veichleId: selectedConfig?.vehicle ?? '',
            veichleDescriptions: null
        };

        postVeichlesByCustomer(data)
        .then(r => {
            if (r.success) {
                setSuccessMessage(t('modalQuantity.successMessageAdd'))
            }
            else {
                setErrorAccessAs(t('modalQuantity.errorMessageAdd'))
            }
        })
        .finally(() => hideModalQuantity())
    }

    const updateVehicleConfig = () => {
        if (Number(selectedConfig?.min ?? '0') > Number(selectedConfig?.max ?? '0')) {
            setValidationError(t('modalQuantity.validation'));
            return;
        }

        const data: VeichleCustomer = {
            id: selectedVehicleItem?.id,
            active: selectedConfig?.active ?? true,
            incoterm: selectedVehicleItem?.incoterm ?? '',
            issuer: selectedCustomer,
            materialCode: selectedVehicleItem?.materialCode ?? '',
            maxValue: Number(selectedConfig?.max ?? '0'),
            minValue: Number(selectedConfig?.min ?? '0'),
            veichleId: selectedVehicleItem?.veichleId ?? '',
            veichleDescriptions: null
        };

        putVeichlesByCustomer(data)
        .then(r => {
            setSuccessMessage(t('modalQuantity.successMessageUpdate'))
        })
        .catch(err => setErrorAccessAs(t('modalQuantity.errorMessageUpdate')))
        .finally(() => hideModalQuantity())
    }

    const openModalQuantityEdit = (item: any) => {
        setSeletecVehicleItem(item);
        setValidationError('');
        setSelectedConfig({
            incoterm: item.incoterm,
            max: item.maxValue,
            min: item.minValue,
            product: item.materialCode
        })
        setModalQuantity({show: true, addShow: false, isEdit: true});
    }

    const accessAs = (issuer: string) => {
        setLoadingAccessAs(true);
        getAccessAsToken(issuer, loginData.email)
        .then(r => {
            if (r.success) {
                const issuerCrypt = encryptByte(r?.data?.customers?.[0]?.issuer);
                const emailCrypt = encryptByte(r?.data?.backofficeEmail);

                const url = `${process.env.REACT_APP_CUSTOMER}?t=${r?.data?.token?.replace(`ey`, `UN`)}&i=${issuerCrypt}&e=${emailCrypt}`;

                window.open(url, `_blank`);
            } else {
                setErrorAccessAs(t('customerScreen.labelErrorAccess'))
            }
        })
        .catch(() => setErrorAccessAs(t('customerScreen.labelErrorAccess')))
        .finally(() => setLoadingAccessAs(false))

        document.body.click();
    }

    const mockDataTable = {
        headers: [
            {
                property: 'issuerName',
                name: t('user.labelName'),
                isName: true
            },
            {
                property: 'issuer',
                name: t('customerScreen.labelCode'),
                isNumber: true,
            },
            {
                property: 'searchTerm1',
                name: t('customerScreen.labelSearch'),
                isEmail: true
            },
            {
                property: 'address',
                name: t('customerScreen.labelAddress'),
            },
            {
                property: 'cnpjCpf',
                name: t('customerScreen.labelDocument'),
                isDoc: true
            },
            {
                property: 'actions',
                name: t('user.labelActions'),
                isAction: true,
                isStatus: false,
            },
        ]
    };

    const mockStatusStyle = [
        {
            name: UserStatus.Active,
            color: '#30c10c',
            bgColor: '#eefff2',
        },
        {
            name: UserStatus.Inactive,
            bgColor: '#FFEFEA',
            color: '#FF6636',
        }
    ];

    const onChangeSearch = (e: ChangeEvent<FormControlElement>) => {
        setSearch({ ...search, search: e?.target?.value });
    }

    const onChangeSearchModal = (e: ChangeEvent<FormControlElement>) => {
        const valueFilter = e?.target?.value?.toUpperCase();
        if (!valueFilter) {
            setVehiclesByCustomerFiltered(vehiclesByCustomer);
            return;
        }

        const filteredList = vehiclesByCustomer?.filter(v => v.incoterm.includes(valueFilter) || v.veichleDescriptions?.some(x => x.description.includes(valueFilter)) || v.materialCode.includes(valueFilter))
        setVehiclesByCustomerFiltered(filteredList);


    }

    const getUsersFromCustomer = (issuer: string, issuerName: string) => {
        let emailsNew: any[] = [];
        setEmails([]);
        setSelectedIssuerName(issuerName);
        setLoadingEmails(true);
        setShowModal(true);
        getUserByCustomerPaged(issuer).then(users => {
            if (users.success) {
                users?.data?.map(u => {
                    emailsNew.push(u.email);
                });

                setEmails(emailsNew);
            }
        }).catch(() => setShowModal(true))
        .finally(() => setLoadingEmails(false))
    }

    // FUNCTION TO SEARCH CUSTOMER WHEN ENTER KEY IS CLICKED
    const handleEnterKey = (event:any) => {
        if(event.key === 'Enter') {
            getUsers();
        }
    }

    return (
        <div className='customer-page'>
            <div className='customer-wrapper'>
                <div className='my-orders-header w-100'>
                    <div className='my-orders-header-i'>
                        <FontAwesomeIcon icon={faIndustry} color='#00FF3C' size='xl' />
                        <p className='w-100'>Clientes</p>
                    </div>
                </div>
                <div className='my-orders-search w-100'>
                    <div>
                        <UniInput
                            id='search'
                            placeholder={t('customerScreen.labelSearchExample')}
                            label='Busca'
                            type='text'
                            onChangeInput={(e) => onChangeSearch(e)}
                            enterKey={handleEnterKey}
                        />
                    </div>
                    <FontAwesomeIcon icon={faSearch} title={t('customerScreen.search')} onClick={() => getUsers()} />
                </div>
                <div className='w-100 d-flex justify-content-center'>
                    <table className='table-uni'>
                        <thead>
                            <tr className='table-header' style={{paddingLeft: 15}}>
                                {
                                    mockDataTable.headers.map(header => (
                                        <td key={header.name} style={header.isStatus ? {
                                            width: 60, textAlign: 'left'
                                        } : header.isAction ? {width: '50%'} : {}}
                                            className={``}>
                                            {
                                                header.isAction ?
                                                <>
                                                    {header.name}
                                                </>
                                                :
                                                <>
                                                    {header.name}
                                                </>
                                            }
                                        </td>
                                    ))
                                }
                            </tr>
                        </thead>
                        {
                            loading ? (
                                <Skeleton
                                    width={'100%'}
                                    height={400}
                                    duration={1}
                                    highlightColor={darkMode ? '#6c6b6b' : '#f5f5f5'}
                                    baseColor={darkMode ? '#021717' : '#ebebeb'} />
                            ) :
                                (
                                    error ? (<p className='w-100 text-center p-2'>{t('customerScreen.searchNotFound')}</p>) :
                                        <tbody>
                                            {
                                                usersCustomers?.map((user: any, idx) => (
                                                    <tr className='item-header'>
                                                        {
                                                            mockDataTable.headers.map(header => {
                                                                if (header.isStatus) {
                                                                    return (
                                                                        <td key={header.name} style={{ maxWidth: 60 }}>
                                                                            <div className='table-status' style={{ backgroundColor: user?.[header.property] ? mockStatusStyle[0].bgColor : mockStatusStyle[1].bgColor ?? '#fff', minWidth: 145 }}>
                                                                                <span className='table-status-icon' style={{ backgroundColor: user?.[header.property] ? mockStatusStyle[0].color : mockStatusStyle[1].color ?? '#fff' }}></span>
                                                                                <div className='w-100' style={{ fontSize: 11 }}>{user?.[header.property] ? t('customerScreen.active') : t('customerScreen.inactive')}</div>
                                                                            </div>
                                                                        </td>
                                                                    );
                                                                }

                                                                if (header.property === 'check') {
                                                                    return (
                                                                        <Form.Check
                                                                            type={'checkbox'}
                                                                            id={`default-check`}
                                                                        />
                                                                    );
                                                                }

                                                                if (header.isNumber) {
                                                                    return (
                                                                        <td key={header.name}>{Number(user?.[header.property])}</td>
                                                                    )
                                                                }
                                                                 if (header.isDoc) {
                                                                    return (
                                                                        <td key={header.name}>{(user?.[header.property])}</td>
                                                                    )
                                                                }

                                                                if (header.isEmail) {
                                                                    return (
                                                                        <td key={header.name} title={user?.[header.property]}>{user?.[header.property] ? user?.[header.property]?.length > 20 ? user?.[header.property]?.slice(0, 19) + '...' : user?.[header.property] : '-'}</td>
                                                                    )
                                                                }

                                                                if (header.isName) {
                                                                    return (
                                                                        <td key={header.name} title={user?.[header.property]}>{user?.[header.property] ? user?.[header.property]?.length > 25 ? user?.[header.property]?.slice(0, 24) + '...' : user?.[header.property] : '-'}</td>
                                                                    )
                                                                }

                                                                if (header.property === 'actions') {
                                                                    return (
                                                                        <td style={{width: '50%'}}>
                                                                            <Dropdown onClick={()=>{getAfterHour(user.issuer)}}>
                                                                                <Dropdown.Toggle>
                                                                                    <FontAwesomeIcon icon={faEllipsis}/>
                                                                                </Dropdown.Toggle>
                                                                                <Dropdown.Menu style={{padding: 0, width: '250px' }}>
                                                                                    <div className='d-flex flex-column actions gap-1'>
                                                                                        <div
                                                                                            className='action-icon'
                                                                                            style={{border: `1px solid`, fontSize: 11}}
                                                                                            onClick={() => {
                                                                                                getUsersFromCustomer(user?.issuer, user?.issuerName);
                                                                                                document.body.click();
                                                                                            }}
                                                                                        >
                                                                                            <FontAwesomeIcon icon={faUsers}/>
                                                                                            {t('customerScreen.listUsers')}
                                                                                        </div>
                                                                                        <div
                                                                                            className='action-icon'
                                                                                            style={{border: `1px solid`, fontSize: 11}}
                                                                                            onClick={() => {
                                                                                                accessAs(user?.issuer);
                                                                                            }}
                                                                                        >
                                                                                            <FontAwesomeIcon icon={faRightFromBracket}/>
                                                                                            {t('customerScreen.accessAs')}
                                                                                        </div>
                                                                                        <div
                                                                                            className='action-icon'
                                                                                            style={{border: `1px solid`, fontSize: 11}}
                                                                                            onClick={() => {
                                                                                                openModalQuantity(user?.issuer, user?.country);
                                                                                            }}
                                                                                        >
                                                                                            <FontAwesomeIcon icon={faTruck}/>
                                                                                            {t('customerScreen.configQtd')}

                                                                                        </div>
                                                                                        <div
                                                                                            className='action-icon'
                                                                                            style={{border: `1px solid`, fontSize: 11}}
                                                                                        >
                                                                                            <Switch onChange={(e)=>{ setAfterHour(user.issuer)  }} checked={toggled} height={20} width={40} />
                                                                                            {t('customerScreen.afterHourOrder')}
                                                                                        </div>
                                                                                    </div>
                                                                                </Dropdown.Menu>
                                                                            </Dropdown>
                                                                        </td>
                                                                    );
                                                                }


                                                                return (
                                                                    <td key={header.name} title={user?.[header.property]}>{user?.[header.property] ? user?.[header.property]?.length > 10 ? user?.[header.property]?.slice(0, 23) + '...' : user?.[header.property] : '-'}</td>
                                                                )
                                                            })
                                                        }
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                )
                        }
                    </table>
                </div>
                {
                    <UniPagination totalItems={totalItems} totalPages={totalPages} changePage={(e) => setPage(e)} changeTake={(e) => { setPage(1); setTake(e) }} />
                }
            </div>
            <UniModal
                icon={faUsers}
                message={t('customerScreen.msgEmailAccess')}
                title={selectedIssuerName ? selectedIssuerName : ``}
                onHide={() => setShowModal(false)}
                show={showModal}
                isFontAwsome
            >
                {
                    loadingEmails ?
                    <>
                        <br/>
                        <Spinner />
                    </>
                    : usersEmail?.length <= 0 ?
                    <>
                        <br/>
                        {t('customerScreen.msgUserNotClient')}
                    </> :
                    usersEmail?.map(u => (
                        <div style={{maxHeight: 200, overflowY: 'auto'}}>
                            <p style={{color: '#027948', fontWeight: 'bold'}}>{u}</p>
                        </div>
                    ))
                }
            </UniModal>

            <UniModal
                icon={faRightFromBracket}
                message={t('customerScreen.prepareAmbient')}
                title={t('customerScreen.accessClient')}
                onHide={() => {}}
                closeButton={false}
                show={loadingAccessAs}
                isFontAwsome
            >
                {
                    <>
                        <br/>
                        <Spinner color='#027948' style={{marginTop: 20}}/>
                    </>
                }
            </UniModal>

            <UniModal
                icon={null}
                message={''}
                title={t('modalQuantity.title')}
                onHide={() => hideModalQuantity()}
                closeButton={true}
                show={modalQuantity?.show ?? false}
                isFontAwsome
                style='modal-dialog-lg'
            >
                {
                    modalQuantity?.addShow ? (
                        <div>
                            <div className='mb-3'>
                                <UniInput
                                    id='product'
                                    disabled={loadingVehicleConfig}
                                    label='Material'
                                    isSelect
                                    onChange={(e) => selectedProduct(e.target.value)}
                                    loading={loadingProduct}
                                >
                                    <option key='-' value='-' disabled selected>
                                        Selecione
                                    </option>
                                    {
                                        customerProducts?.map(material =>
                                        (
                                            <option key={material.materialCode} value={material.materialCode}>
                                                {Number(material.materialCode)} - {material.descriptions?.filter(d => d.language === i18n.language)?.[0]?.description ?? material.descriptions?.[0]?.description}
                                            </option>
                                        ))
                                    }
                                </UniInput>
                            </div>
                            <div className='d-flex justify-content-between gap-2 mb-3'>
                                <div className='w-100'>
                                    <UniInput
                                        id='incoterm'
                                        disabled={!enableModalInputs}
                                        label='Incoterm'
                                        isSelect
                                        onChange={e => setSelectedConfig({...selectedConfig, incoterm: e.target.value})}
                                        loading={loadingVehicleConfig}
                                    >
                                        {
                                            customerIncoterms?.map(incoterm =>
                                            (
                                                <option key={incoterm} value={incoterm}>
                                                    {incoterm}
                                                </option>
                                            ))
                                        }
                                    </UniInput>
                                </div>
                                <div className='w-100'>
                                    <UniInput
                                        id='vehicle'
                                        disabled={!enableModalInputs}
                                        label='Tipo de veículo'
                                        isSelect
                                        onChange={e => setSelectedConfig({...selectedConfig, vehicle: e.target.value})}
                                        loading={loadingVehicleConfig}
                                    >
                                        {
                                            customerVehicles?.map(vei =>
                                            (
                                                <option key={vei.id} value={vei.id}>
                                                    {vei.description}
                                                </option>
                                            ))
                                        }
                                    </UniInput>
                                </div>
                            </div>
                            <div className='d-flex justify-content-between gap-2 mb-3'>
                                <div className='w-100'>
                                    <UniInput
                                        id='minQtd'
                                        disabled={!enableModalInputs}
                                        label='Quantidade mínima (ton)'
                                        placeholder='0'
                                        type='number'
                                        onChangeInput={e => {
                                            setSelectedConfig({...selectedConfig, min: e.target.value});
                                            setValidationError('');
                                        }}
                                    />
                                </div>
                                <div className='w-100'>
                                    <UniInput
                                        id='maxQtd'
                                        disabled={!enableModalInputs}
                                        label='Quantidade máxima (ton)'
                                        placeholder='0'
                                        type='number'
                                        onChangeInput={e => {
                                            setSelectedConfig({...selectedConfig, max: e.target.value});
                                            setValidationError('');
                                        }}
                                    />
                                </div>
                            </div>
                            <div className='d-flex justify-content-end gap-3'>
                                <span style={{color: '#EA2027'}}>{validationError}</span>
                                <Button
                                    variant='outline'
                                    onClick={() =>  {
                                        setModalQuantity({addShow: false, show: true, isEdit: false});
                                        setSelectedConfig({});
                                        setCustomerProducts(null);
                                        setCustomerIncoterms(null);
                                        setCustomerVehicles(null);
                                    }}>
                                        {t('modalQuantity.btnBack')}
                                </Button>
                                <Button disabled={
                                    !selectedConfig?.product ||
                                    !selectedConfig?.incoterm ||
                                    !selectedConfig?.vehicle ||
                                    !selectedConfig?.min ||
                                    !selectedConfig?.max
                                }
                                onClick={() => addVehicleConfig()}>
                                    {t('modalQuantity.btnSave')}
                                </Button>
                            </div>
                        </div>
                    ) :
                    modalQuantity?.isEdit ? (
                        <div>
                            <div className='mb-3'>
                                <UniInput
                                    id='product'
                                    disabled={true}
                                    label='Material'
                                    value={selectedVehicleItem?.materialCode}
                                />
                            </div>
                            <div className='d-flex justify-content-between gap-2 mb-3'>
                                <div className='w-100'>
                                    <UniInput
                                        id='incoterm'
                                        disabled={true}
                                        label='Incoterm'
                                        value={selectedVehicleItem?.incoterm}
                                    />
                                </div>
                                <div className='w-100'>
                                    <UniInput
                                        id='vehicle'
                                        disabled={true}
                                        label='Tipo de veículo'
                                        value={selectedVehicleItem?.veichleDescriptions?.[0]?.description}
                                    />
                                </div>
                            </div>
                            <div className='d-flex justify-content-between gap-2 mb-3'>
                                <div className='w-100'>
                                    <UniInput
                                        id='minQtd'
                                        label='Quantidade mínima (ton)'
                                        placeholder='0'
                                        type='number'
                                        defaultValue={selectedVehicleItem?.minValue}
                                        onChangeInput={e => {
                                            setSelectedConfig({...selectedConfig, min: e.target.value});
                                            setValidationError('');
                                        }}
                                    />
                                </div>
                                <div className='w-100'>
                                    <UniInput
                                        id='maxQtd'
                                        label='Quantidade máxima (ton)'
                                        placeholder='0'
                                        type='number'
                                        defaultValue={selectedVehicleItem?.maxValue}
                                        onChangeInput={e => {
                                            setSelectedConfig({...selectedConfig, max: e.target.value});
                                            setValidationError('');
                                        }}
                                    />
                                </div>
                            </div>
                            <div className='d-flex justify-content-start gap-2 mb-3'>
                                <Form.Check
                                    inline
                                    label={'Ativo'}
                                    name='active'
                                    value='0'
                                    type='radio'
                                    defaultChecked={true}
                                    onChange={(e) => setSelectedConfig({...selectedConfig, active: true})}
                                />
                                <Form.Check
                                    inline
                                    label={'Inativo'}
                                    name='active'
                                    value='1'
                                    type='radio'
                                    onChange={(e) => setSelectedConfig({...selectedConfig, active: false})}
                                />
                            </div>

                            <div className='d-flex justify-content-end gap-3'>
                                <span style={{color: '#EA2027'}}>{validationError}</span>
                                <Button
                                    variant='outline'
                                    onClick={() =>  {
                                        setModalQuantity({addShow: false, show: true, isEdit: false});
                                        setSelectedConfig({});
                                        setCustomerProducts(null);
                                        setCustomerIncoterms(null);
                                        setCustomerVehicles(null);
                                    }}>
                                        {t('modalQuantity.btnBack')}
                                </Button>
                                <Button onClick={() => updateVehicleConfig()}>{t('modalQuantity.btnSave')}</Button>
                            </div>
                        </div>
                    ) :
                    (
                        <div>
                            <div className='d-flex align-items-baseline'>
                                <UniInput
                                    id='search-modal'
                                    placeholder={t('modalQuantity.searchPlaceholder')}
                                    type='text'
                                    defaultValue={''}
                                    onChangeInput={(e) => onChangeSearchModal(e)}
                                    props={
                                        {
                                            size: 'sm',
                                        }
                                    }
                                />
                                <Button className='m-3' onClick={() => getCustomerMaterials()}>{t('modalQuantity.btnAdd')}</Button>
                            </div>

                            <table className='table-uni'>
                                <thead>
                                    <tr className='table-header'>
                                        <td>Incoterm</td>
                                        <td>SKU</td>
                                        <td>{t('modalQuantity.columnVehicle')}</td>
                                        <td>Min.</td>
                                        <td>Máx.</td>
                                        <td>Status</td>
                                        <td></td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        vehiclesByCustomerFiltered?.map(v => (
                                            <tr className='item-header'>
                                                <td>{v.incoterm}</td>
                                                <td>{v.materialCode}</td>
                                                <td>{v.veichleDescriptions?.[0]?.description}</td>
                                                <td>{v.minValue}</td>
                                                <td>{v.maxValue}</td>
                                                <td>{v.active ? 'Ativo' : 'Inativo'}</td>
                                                <td className='actions-modal d-flex align-items-center justify-content-center h-100 gap-2'>
                                                    <FontAwesomeIcon icon={faEdit} title='Editar' style={{cursor:'pointer'}} onClick={() => openModalQuantityEdit(v)}/>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    )
                }
            </UniModal>


            <UniModal
                icon={faCheckCircle}
                message=''
                iconColor='#00FF3C'
                title={successMessage}
                onHide={() => {
                    setSuccessMessage('');
                    openModalQuantity(selectedCustomer);
                }}
                show={successMessage !== ''}
                isFontAwsome
            />
            <UniModal
                icon={faXmarkCircle}
                message=''
                iconColor='#EA2027'
                title={errorAccessAs}
                onHide={() => {setErrorAccessAs('')}}
                show={errorAccessAs !== ''}
                isFontAwsome
            />
        </div>
    );
}

export default Customers;